"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryMovementAnnotationCategory = exports.InventoryMovementCategory = exports.InventoryMovementType = exports.InventoryDetailExceptionType = void 0;
var InventoryDetailExceptionType;
(function (InventoryDetailExceptionType) {
    InventoryDetailExceptionType["NODE_NO_PRODUCT"] = "NODE_NO_PRODUCT";
})(InventoryDetailExceptionType = exports.InventoryDetailExceptionType || (exports.InventoryDetailExceptionType = {}));
var InventoryMovementType;
(function (InventoryMovementType) {
    InventoryMovementType["RECEIVE"] = "RECEIVE";
    InventoryMovementType["RETURN"] = "RETURN";
    InventoryMovementType["ADJUSTMENT"] = "ADJUSTMENT";
    InventoryMovementType["OUTBOUND"] = "OUTBOUND";
    InventoryMovementType["OTHER"] = "OTHER";
    InventoryMovementType["QUARANTINE"] = "QUARANTINE";
    InventoryMovementType["DAMAGE"] = "DAMAGE";
    InventoryMovementType["COUNT"] = "COUNT";
    InventoryMovementType["SHIPPED"] = "SHIPPED";
    InventoryMovementType["RELOCATE"] = "RELOCATE";
})(InventoryMovementType = exports.InventoryMovementType || (exports.InventoryMovementType = {}));
var InventoryMovementCategory;
(function (InventoryMovementCategory) {
    InventoryMovementCategory["ADJUSTMENT"] = "Adjustment";
    InventoryMovementCategory["ALLOCATION"] = "Allocation";
    InventoryMovementCategory["AUDIT"] = "Audit";
    InventoryMovementCategory["CHANGE_ATTRIBUTE"] = "Change_Attribute";
    InventoryMovementCategory["CHANGE_ITEM"] = "Change_Item";
    InventoryMovementCategory["CHANGE_PRODUCT"] = "Change_Product";
    InventoryMovementCategory["CONSOLIDATION"] = "Consolidation";
    InventoryMovementCategory["COUNT"] = "Count";
    InventoryMovementCategory["DISPOSED"] = "Disposed";
    InventoryMovementCategory["EXPIRED"] = "Expired";
    InventoryMovementCategory["FOUND"] = "Found";
    InventoryMovementCategory["LOST"] = "Lost";
    InventoryMovementCategory["LOADING"] = "Loading";
    InventoryMovementCategory["OTHER"] = "Other";
    InventoryMovementCategory["PACK"] = "Pack";
    InventoryMovementCategory["PICK"] = "Pick";
    InventoryMovementCategory["QUARANTINE"] = "Quarantine";
    InventoryMovementCategory["RECEIVE"] = "Receive";
    InventoryMovementCategory["RECEIPT_CORRECTION"] = "Receipt_Correction";
    InventoryMovementCategory["RELOCATE"] = "Relocate";
    InventoryMovementCategory["RESERVE"] = "Reserve";
    InventoryMovementCategory["RETURN"] = "Return";
    InventoryMovementCategory["SHIPMENT"] = "Shipment";
    InventoryMovementCategory["SHIPMENT_CORRECTION"] = "Shipment_Correction";
    InventoryMovementCategory["SORTING"] = "Sorting";
    InventoryMovementCategory["TRANSFER"] = "Transfer";
    InventoryMovementCategory["TRANSFER_IN"] = "Transfer_In";
    InventoryMovementCategory["TRANSFER_OUT"] = "Transfer_Out";
    InventoryMovementCategory["TRANSFER_CORRECTION"] = "Transfer_Correction";
})(InventoryMovementCategory = exports.InventoryMovementCategory || (exports.InventoryMovementCategory = {}));
var InventoryMovementAnnotationCategory;
(function (InventoryMovementAnnotationCategory) {
    InventoryMovementAnnotationCategory["CHANGE_ATTRIBUTE"] = "Change_Attribute";
    InventoryMovementAnnotationCategory["CHANGE_PRODUCT"] = "Change_Product";
    InventoryMovementAnnotationCategory["COUNT"] = "Count";
    InventoryMovementAnnotationCategory["DISPOSED"] = "Disposed";
    InventoryMovementAnnotationCategory["EXPIRED"] = "Expired";
    InventoryMovementAnnotationCategory["FOUND"] = "Found";
    InventoryMovementAnnotationCategory["LOST"] = "Lost";
    InventoryMovementAnnotationCategory["RECEIPT_CORRECTION"] = "Receipt_Correction";
    InventoryMovementAnnotationCategory["RECEIVE"] = "Receive";
    InventoryMovementAnnotationCategory["RETURN"] = "Return";
    InventoryMovementAnnotationCategory["SHIPMENT"] = "Shipment";
    InventoryMovementAnnotationCategory["SHIPMENT_CORRECTION"] = "Shipment_Correction";
    InventoryMovementAnnotationCategory["TRANSFER"] = "Transfer";
})(InventoryMovementAnnotationCategory = exports.InventoryMovementAnnotationCategory || (exports.InventoryMovementAnnotationCategory = {}));
//# sourceMappingURL=WarehouseInventory.js.map